import { xlCol, xlColq } from '../../common/constants'

const getCommonHeaders = (translations) => {
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  return [
    { headerName: op.sn || 'SN', field: 'SN', xlCol: xlCol, weight: 30 },
    { headerName: op.expenseDate || 'Expense Date', field: 'FormattedDate', xlCol: xlCol, weight: 90 },
    { headerName: op.head || 'Head', field: 'HeadName', xlCol: xlCol, weight: 80 },
    { headerName: op.subHead || 'Sub-Head', field: 'SubHeadName', xlCol: xlCol, weight: 80 },
    { headerName: op.selectModeCol || 'Select Mode', field: 'Mode', xlCol: xlCol, weight: 50 },
    { headerName: cs.amount || 'Amount', field: 'ExpenseAmount', xlCol: xlColq, weight: 50 },
    { headerName: op.narration || 'Narration', field: 'Narration', xlCol: xlCol, weight: 60 },
  ]
}

export const getSelectModeData = (translations) => {
  const op = translations?.operationsPrivilege || {}
  return [
    { id: 1, name: op.paid || 'Paid', apiValue: 'Paid' },
    { id: 2, name: op.received || 'Received', apiValue: 'Received' },
  ]
}

export const getCityBranchHeaders = (translations) => {
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  return [
    { headerName: cs.city || 'City', field: 'CityName', xlCol: xlCol, weight: 80 },
    { headerName: cs.branch || 'Branch', field: 'Branchname', xlCol: xlCol, weight: 120 },
    { headerName: op.user || 'User', field: 'UserName', xlCol: xlCol, weight: 80 },
  ]
}

export const getExEntryHeaders = (translations) => {
  const cs = translations?.common || {}
  return [...getCommonHeaders(translations), { headerName: cs.action || 'Action', field: 'action', xlCol: xlCol, align: 'center', weight: 30 }]
}

export const getExApprovalHeaders = (translations) => {
  const op = translations?.operationsPrivilege || {}
  return [...getCommonHeaders(translations), { headerName: op.approval || 'Approval', field: 'approval', xlCol: xlCol, weight: 30 }]
}

export const getExReportHeaders = (translations) => {
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  return [
    ...getCommonHeaders(translations),
    { headerName: cs.status || 'Status', field: 'Status', xlCol: xlCol, weight: 50 },
    { headerName: op.rejectRemarks || 'Reject Remarks', field: 'RejectionRemarks', xlCol: xlCol, width: '200px', weight: 60 },
  ]
}

export const getCriteriaHeaders = (translations) => {
  const op = translations?.operationsPrivilege || {}
  const cs = translations?.common || {}
  return [
    { field: 'fromDate', header: cs.fromDate || 'From Date', textAlign: 'left' },
    { field: 'toDate', header: cs.toDate || 'To Date', textAlign: 'left' },
    { field: 'selCity', header: cs.city || 'City', textAlign: 'left' },
    { field: 'selBranch', header: cs.branch || 'Branch', textAlign: 'left' },
    { field: 'user', header: op.user || 'User', textAlign: 'left' },
    { field: 'status', header: cs.status || 'Status', textAlign: 'left' },
  ]
}

export const EXPENSE_TAB_JOB_IDS = [573, 574, 575]

export const getExpenseTabsList = (translations) => {
  const op = translations?.operationsPrivilege || {}
  return [
    { JobID: 573, name: op.expenseEntry || 'EXPENSE ENTRY' },
    { JobID: 574, name: op.expenseApproval || 'EXPENSE APPROVAL' },
    { JobID: 575, name: op.approvedReport || 'APPROVED REPORT' },
  ]
}

export const getStatusList = (translations) => {
  const op = translations?.operationsPrivilege || {}
  return [
    { id: 1, name: op.approved || 'Approved', apiValue: 'Approved' },
    { id: 2, name: op.rejected || 'Rejected', apiValue: 'Rejected' },
  ]
}
